export enum PatientReturnStatus {
  Returning = "returning-patient",
  New = "new-patient",
  Unknown = "patient",
}
